export const getCurrency = () => ({
  id: sessionStorage.getItem("currencyId") || "",
  name: sessionStorage.getItem("currencyName") || "",
  symbol: sessionStorage.getItem("currencySymbol") || "AED",
  rate: Number(sessionStorage.getItem("currencyRate") || 1),
});